export default __webpack_public_path__ + "25994e9100af576795f8754a04da3eb4.png";